import { Grid } from "@mui/material";
import { useState } from 'react';
import LoadingComponent from "../../common/components/LoadingComponent";
import Button from '@mui/material/Button';
import MicrosoftLogo from '../../img/microsoft_icon_monotone.svg';

export default function MicrosoftLogin(props) {
    const [isLoading] = useState(false);

     const login = (e) => {
        e?.preventDefault();

        window.location.href =
            `${process.env.REACT_APP_API_DOMAIN}saml/login/`;
    };

    return (
        <>
            <Grid textAlign='center' sx={{ my: 1 }}>
                    {
                        isLoading ? <LoadingComponent /> :
                            <Button
                                type="button"
                                startIcon={ 
                                    <img
                                        src={MicrosoftLogo}
                                        alt="Microsoft"
                                        style={{
                                            width: 20,
                                            height: 20,
                                        }}
                                    />
                                }
                                size="large"
                                variant="contained"
                                disabled={props.disabled}
                                onClick={() => { login() }}
                                sx={{ my: 1, width: "100%", fontFamily: "Henry Sans", variant: "h6" }}>Sign in with Microsoft
                            </Button>
                    }
            </Grid>
        </>
    )
}